import React, { useCallback, useEffect, useRef, useState } from "react";
import { FaTrash } from "react-icons/fa";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { useSnackbar } from "notistack";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch } from "react-redux";
import { getTrainingFiles, uploadTrainingFile } from "../../store/slices/MyTraining/myTrainingFileUploadSlice";
import { deleteFile } from "../../store/slices/FileDataSlice";

const FileUploadMyTraining = ({
    training,
    setSelectedFile, 
    selectedFile,
    popupProject, 
    setPopupProject,
    getTrainingFileData,
    isViewOnly = false
}) => {
    const trainingId = training?._id
    const dispatch = useDispatch()
    const { enqueueSnackbar } = useSnackbar();
    const [SelectedCategory, setSelectedCategory] = useState("");
    const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
    const [fileNames, setFileNames] = useState([]);
    const auth = localStorage.getItem("auth");
    // const { uploadedData } = useSelector((s) => s.myTrainingFileUpload);

    // useEffect(() => {
    //     dispatch(getTrainingFiles(trainingId));
    // }, [trainingId, dispatch]);

    // const getTrainingFileData = useCallback(() => {
    //     if (!trainingId) return;
    //     dispatch(getTrainingFiles(trainingId));
    // }, [trainingId, dispatch]);


    // useEffect(() => {
    //     // if uploadedData is null, undefined, 0, "" → set empty array
    //     if (!uploadedData) {
    //         setSelectedFile([]);
    //         return;
    //     }

    //     // if it's already an array
    //     if (Array.isArray(uploadedData)) {
    //         setSelectedFile(uploadedData);
    //         return;
    //     }

    //     // if backend returned a single file object
    //     setSelectedFile([uploadedData]);
    // }, [uploadedData, setSelectedFile]);

    const dropdownRefProbability = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRefProbability.current &&
                !dropdownRefProbability.current.contains(event.target)
            ) {
                setShowCategoryDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleFileDownload = (fileData) => {
        if (isViewOnly) return;
        if (fileData?.filepathurl) {
            try {
                if (!fileData || !fileData.filepathurl) {
                    throw new Error("Invalid file data");
                }

                const fileUrl = fileData.filepathurl;
                const fileName = fileData.filename || fileUrl.split("/").pop();

                const link = document.createElement("a");
                link.href = fileUrl;
                link.setAttribute("download", fileName);
                link.setAttribute("target", "_blank");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                enqueueSnackbar("File download started", { variant: "success" });
            } catch (error) {
                console.error("Download failed:", error);
            }
        } else {
            const url = fileData.preview || URL.createObjectURL(fileData.file);

            const link = document.createElement("a");
            link.href = url;
            link.download = fileData.name || "downloaded-file";

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Optional cleanup if you created the URL
            if (!fileData.preview) {
                URL.revokeObjectURL(url);
            }
        }
    };



    const handleFileChange = (e) => {
        if (isViewOnly) return;
        const selectedFiles = Array.from(e.target.files);
        const allowedFormats = [
            "application/pdf",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ];

        if (!SelectedCategory) {
            enqueueSnackbar("Please select a category first", { variant: "error" });
            return;
        }

        const validFiles = [];

        selectedFiles.forEach((file) => {
            if (!allowedFormats.includes(file.type)) {
                enqueueSnackbar(`Invalid file type (${file.name})`, { variant: "error" });
                return;
            }
            validFiles.push({
                file,                                                // real file object
                preview: URL.createObjectURL(file),                 // preview for UI
                selectedCategory: SelectedCategory,
                name: file.name,
                type: file.type,
                trainingId: training?._id,
            });
        });

        if (validFiles.length === 0) return;
        setSelectedFile((prev) => [...prev, ...validFiles])
        setFileNames((prev) => [...prev, ...validFiles]);       // ✅ show using map
        handleFileUpload(training?._id, validFiles);            // send to API
        setSelectedCategory("");
        e.target.value = null;
    };

    const handleFileUpload = useCallback(
        async (id, files) => {
            if (!trainingId) return
            if (!files?.length) return;
            const selectedCategory = files[0]?.selectedCategory; // assuming same category for all
            const rawFiles = files.map(f => f.file);
            try {
                await dispatch(
                    uploadTrainingFile({
                        trainingId: id,
                        selectedCategory,
                        files: rawFiles
                    })
                ).unwrap();
                getTrainingFileData(id)
                enqueueSnackbar(`Files uploaded successfully`, { variant: "success" });
            } catch (err) {
                console.error(err);
            }
        },
        [dispatch, enqueueSnackbar, trainingId, getTrainingFileData]
    );


    const handleFileDelete = async (file) => {
        if (isViewOnly) return;
        const id = file.id;
        try {
            await dispatch(deleteFile(id)).unwrap();
            getTrainingFileData()
            enqueueSnackbar("File Deleted Successfully", { variant: "success" });
            dispatch(getTrainingFiles(trainingId));
        } catch (error) {
            console.error("Error deleting file:", error);
        } finally {
            if (selectedFile?.length === 1) {
                setSelectedFile([])
            }
        }
    };


    return (
        <div>
                <div className="fixed w-full inset-0 bg-black/50 flex items-center justify-center z-[1600]">
                    <div className="w-[50%] bg-white shadow-lg rounded-lg p-6">
                        <div className="flex justify-between items-center mb-6">
                            <div className="flex align-middle items-center gap-2">
                                <h2 className="text-lg font-bold">Attachments </h2>
                                <p>({"Project Name : "}{training?.projectname || " "})</p>
                            </div>              <button
                                className="text-gray-500 hover:text-black"
                                onClick={() => {
                                    setPopupProject(false)
                                    if(trainingId){
                                        setSelectedFile([]);
                                    }
                                }}
                            >
                                Close
                            </button>
                        </div>
                        <div className="flex gap-2">
                            <div className="relative bg-white">
                                <div
                                    ref={dropdownRefProbability}
                                    className=" flex  p-0  rounded-xl align-middle text-[12px]"
                                >
                                    <button
                                        type="button"
                                        disabled={isViewOnly}
                                        onClick={() => {
                                            if (isViewOnly) return;
                                            setShowCategoryDropdown(!showCategoryDropdown);
                                        }}
                                        className={`border relative w-24 h-8 border-gray-400 text-nowrap rounded-md p-2 shadow-md overflow-hidden outline-none flex items-center justify-between bg-gray-200 ${isViewOnly
                                            ? "opacity-50 cursor-not-allowed"
                                            : ""
                                        }`}
                                    >
                                        <p className="text-left text-xs truncate">
                                            {SelectedCategory ? SelectedCategory : "Category"}
                                        </p>
                                        <ExpandMoreIcon
                                            color="white"
                                            className="cursor-pointer bg-gray-200 flex-shrink-0"
                                        />
                                    </button>

                                    {showCategoryDropdown && (
                                        <div
                                            style={{ zIndex: 9999 }}
                                            className="absolute text-start top-full left-0 w-40 p-1 cursor-pointer max-h-96 overflow-y-auto bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
                                        >
                                            {(auth === "L3" || auth === "L2") && (
                                                <>
                                                    <div
                                                        className="p-1 hover:bg-gray-200 cursor-pointer"
                                                        onClick={() => {
                                                            setSelectedCategory("Quote");
                                                            setShowCategoryDropdown(!showCategoryDropdown);
                                                        }}
                                                    >
                                                        Quote
                                                    </div>
                                                    <div
                                                        className="p-1 hover:bg-gray-200 cursor-pointer"
                                                        onClick={() => {
                                                            setSelectedCategory("Purchase Order");
                                                            setShowCategoryDropdown(!showCategoryDropdown);
                                                        }}
                                                    >
                                                        Purchase Order
                                                    </div>
                                                </>
                                            )}
                                            <div
                                                className="p-1 hover:bg-gray-200 cursor-pointer"
                                                onClick={() => {
                                                    setSelectedCategory("Contract");
                                                    setShowCategoryDropdown(!showCategoryDropdown);
                                                }}
                                            >
                                                Contract
                                            </div>
                                            <div
                                                className="p-1 hover:bg-gray-200 cursor-pointer"
                                                onClick={() => {
                                                    setSelectedCategory("Communication");
                                                    setShowCategoryDropdown(!showCategoryDropdown);
                                                }}
                                            >
                                                Communication
                                            </div>
                                            <div
                                                className="p-1 hover:bg-gray-200 cursor-pointer"
                                                onClick={() => {
                                                    setSelectedCategory("Miscellaneous");
                                                    setShowCategoryDropdown(!showCategoryDropdown);
                                                }}
                                            >
                                                Miscellaneous
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="flex items-center">
                                <label
                                    className={`text-xs p-2 w-24 h-8 text-center rounded-md flex items-center justify-center ${isViewOnly
                                        ? "bg-gray-300 text-gray-600 cursor-not-allowed opacity-50 pointer-events-none"
                                        : !SelectedCategory
                                        ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                                        : "bg-gray-800 text-white hover:text-black hover:bg-gray-300 cursor-pointer"
                                        }`}
                                >
                                    <span>Upload File</span>
                                    <input
                                        type="file"
                                        multiple
                                        className="hidden"
                                        onChange={(e) => handleFileChange(e)}
                                        disabled={isViewOnly || !SelectedCategory}
                                    />
                                </label>

                                <p className="truncate text-xs pl-1">
                                    {fileNames?.name || "No file selected"}
                                </p>
                                <div className="flex gap-2 text-red-500 text-[12px] pl-3">
                                    <p> only .pdf, .xlsx and .docx allowed</p>
                                </div>
                            </div>
                        </div>
                        <div className="w-full mt-4 text-left border-collapse text-[13px]">
                            <div>
                                <div className="border-b flex w-full">
                                    <div className="py-2 px-4 w-[15%]">Sr. No.</div>
                                    <div className="py-2 px-4 w-[40%]">File Name</div>
                                    <div className="py-2 px-4 text-center w-[15%]">Category</div>
                                    <div className="py-2 px-4 text-center w-[15%]">Download</div>
                                    <div className="py-2 px-4 text-center w-[15%]">Delete</div>
                                </div>
                            </div>
                            <div>

                                {selectedFile.map((file, index) => (
                                    <div className="border-b flex w-full" key={file.id ?? index}>
                                        <div className="py-2 px-4 w-[15%]">{index + 1}</div>

                                        <div className="py-2 px-4 w-[40%] truncate overflow-hidden">
                                            {file.name || file.filename}
                                        </div>

                                        <div className="py-2 px-4 w-[15%] text-center truncate">
                                            {file.selectedCategory || file.category}
                                        </div>

                                        <div className="py-2 px-4 text-center w-[15%]">
                                            <button
                                                onClick={() => { if (!isViewOnly) handleFileDownload(file); }}
                                                disabled={isViewOnly}
                                                className={`text-white px-2 py-1 rounded ${isViewOnly ? "bg-blue-500 opacity-50 cursor-not-allowed" : "bg-blue-500 hover:bg-blue-700"}`}
                                            >
                                                <CloudDownloadIcon />
                                            </button>
                                        </div>

                                        <div className="py-2 px-4 text-center w-[15%]">
                                            <button
                                                disabled={isViewOnly}
                                                onClick={() => handleFileDelete(file)}
                                                className={`text-white px-2 py-2 rounded ${isViewOnly
                                                    ? "bg-red-500 opacity-50 cursor-not-allowed"
                                                    : "bg-red-500 hover:bg-red-700"
                                                }`}
                                            >
                                                <FaTrash size={18} />
                                            </button>
                                        </div>
                                    </div>
                                ))}

                            </div>
                        </div>
                    </div>
                </div>
      
        </div>
    );
};

export default FileUploadMyTraining;




// import React, { useEffect, useRef, useState } from 'react'
// import { FaTrash } from "react-icons/fa";
// import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";


// const FileUploadMyTraining = ({
//     selectedProject
// }) => {

//     const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
//     const [SelectedCategory, setSelectedCategory] = useState("");

//     const [showModal, setShowModal] = useState(false)

//     const auth = localStorage.getItem("auth");

//     const dropdownRefProbability = useRef(null);
//     useEffect(() => {
//         const handleClickOutside = (event) => {
//             if (
//                 dropdownRefProbability.current &&
//                 !dropdownRefProbability.current.contains(event.target)
//             ) {
//                 setShowCategoryDropdown(false);
//             }
//         };
//         document.addEventListener("mousedown", handleClickOutside);
//         return () => {
//             document.removeEventListener("mousedown", handleClickOutside);
//         };
//     }, []);

//     const filesToDisplay = [];


//     return (
//         <div>
//             <div>

//             </div>
//             {showModal && (
//                 <div className="fixed w-full inset-0 bg-black/50 flex items-center justify-center z-[3999]">
//                     <div className="w-[50%] bg-white shadow-lg rounded-lg p-6">
//                         <div className="flex justify-between items-center mb-6">
//                             <div className="flex align-middle items-center gap-2">
//                                 <h2 className="text-lg font-bold">Attachments </h2>
//                                 (<p>{selectedProject?.ProjectName}</p>)
//                             </div>            <button
//                                 className="text-gray-500 hover:text-black"
//                                 onClick={() => setShowModal(false)}
//                             >
//                                 Close
//                             </button>
//                         </div>
//                         <div className="flex gap-2">
//                             <div className="relative bg-white">
//                                 <div
//                                     ref={dropdownRefProbability}
//                                     className=" flex  p-0  rounded-xl align-middle"
//                                 >
//                                     <button
//                                         type="button"
//                                         onClick={() =>
//                                             setShowCategoryDropdown(!showCategoryDropdown)
//                                         }
//                                         className="border relative w-24 border-gray-400 text-nowrap rounded-md p-2  shadow-md overflow-hidden bg-gray-200 outline-none"
//                                     >
//                                         <p className="text-left">
//                                             {SelectedCategory ? SelectedCategory : "Category"}
//                                         </p>
//                                         <ExpandMoreIcon
//                                             color="white"
//                                             className="absolute cursor-pointer right-0 top-2 bg-gray-200"
//                                         />
//                                     </button>

//                                     {showCategoryDropdown && (
//                                         <div
//                                             style={{ zIndex: 9999 }}
//                                             className="absolute top-full left-0 w-40 p-1 cursor-pointer max-h-96 overflow-y-auto bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
//                                         >
//                                             {(auth === "L3" || auth === "L2") && (
//                                                 <>
//                                                     <div
//                                                         className="p-1 hover:bg-gray-200 cursor-pointer"
//                                                         onClick={() => {
//                                                             setSelectedCategory("Quote");
//                                                             setShowCategoryDropdown(!showCategoryDropdown);
//                                                         }}
//                                                     >
//                                                         Quote
//                                                     </div>
//                                                     <div
//                                                         className="p-1 hover:bg-gray-200 cursor-pointer"
//                                                         onClick={() => {
//                                                             setSelectedCategory("Purchase Order");
//                                                             setShowCategoryDropdown(!showCategoryDropdown);
//                                                         }}
//                                                     >
//                                                         Purchase Order
//                                                     </div>
//                                                 </>
//                                             )}
//                                             <div
//                                                 className="p-1 hover:bg-gray-200 cursor-pointer"
//                                                 onClick={() => {
//                                                     setSelectedCategory("Contract");
//                                                     setShowCategoryDropdown(!showCategoryDropdown);
//                                                 }}
//                                             >
//                                                 Contract
//                                             </div>
//                                             <div
//                                                 className="p-1 hover:bg-gray-200 cursor-pointer"
//                                                 onClick={() => {
//                                                     setSelectedCategory("Communication");
//                                                     setShowCategoryDropdown(!showCategoryDropdown);
//                                                 }}
//                                             >
//                                                 Communication
//                                             </div>
//                                             <div
//                                                 className="p-1 hover:bg-gray-200 cursor-pointer"
//                                                 onClick={() => {
//                                                     setSelectedCategory("Miscellaneous");
//                                                     setShowCategoryDropdown(!showCategoryDropdown);
//                                                 }}
//                                             >
//                                                 Miscellaneous
//                                             </div>
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>
//                             <div className="flex items-center">
//                                 <label
//                                     className={`text-xs p-2 rounded-md ${!SelectedCategory
//                                         ? "bg-gray-300 text-gray-600 cursor-not-allowed"
//                                         : "bg-gray-800 text-white hover:text-black hover:bg-gray-300 cursor-pointer"
//                                         }`}
//                                 >
//                                     <span>Upload File</span>
//                                     <input
//                                         type="file"
//                                         multiple
//                                         className="hidden"
//                                         disabled={!SelectedCategory}
//                                     />
//                                 </label>

//                                 <p className="truncate text-xs pl-1">
//                                     {"No file selected"}
//                                 </p>
//                                 <div className="flex gap-2 text-red-500 text-[12px] pl-3">
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="w-full mt-4 text-left border-collapse">
//                             <div>
//                                 <div className="border-b flex w-full">
//                                     <div className="py-2 px-4 w-[15%]">Sr. No.</div>
//                                     <div className="py-2 px-4 w-[40%]">File Name</div>
//                                     <div className="py-2 px-4 text-center w-[15%]">Category</div>
//                                     <div className="py-2 px-4 text-center w-[15%]">Download</div>
//                                     <div className="py-2 px-4 text-center w-[15%]">Delete</div>
//                                 </div>
//                             </div>
//                             <div>
//                                 {filesToDisplay.map((file, index) => (
//                                     <div className="border-b flex w-full" key={file.id ?? index}>
//                                         <div className="py-2 px-4 w-[15%]">{index + 1}</div>
//                                         <div className="py-2 px-4 w-[40%] truncate overflow-hidden">{file.filename || file.name}</div>
//                                         <div className="py-2 px-4 w-[15%] text-center truncate">
//                                             {file.category || file.selectedCategory}
//                                         </div>
//                                         <div className="py-2 px-4 text-center w-[15%]">
//                                             <button
//                                                 className="bg-blue-500 text-white px-2 py-1 rounded hover:bg-blue-700"
//                                             >
//                                                 <CloudDownloadIcon />
//                                             </button>
//                                         </div>
//                                         <div className="py-2 px-4 text-center w-[15%]">
//                                             <button
//                                                 className="bg-red-500 text-white px-2 py-2 rounded hover:bg-red-700"
//                                             >
//                                                 <FaTrash size={18} />
//                                             </button>
//                                         </div>
//                                     </div>
//                                 ))}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}

//         </div>
//     )
// }

// export default FileUploadMyTraining
